<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-payroll-contribution-or-deduction-dialog-create
          v-if="$hasPermissionTo(['create contribution or deductions'])"
          @created="loadCoDs"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="CoD's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in CoD here"
          append-icon="search"
          label="Search CoD"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>
  
    <v-data-table
      :items="filteredCoDs" 
      :headers="headers"
      :search="search"
      :single-expand="true"
      show-expand
      hide-default-footer
      :loading="tableLoading"
    >
      <template v-slot:item="props">
        <tr>
          <td :class="props.isExpanded?'remove-bottom-border selected':'border-bottom'">
            <v-btn
              icon
              @click="props.expand(!props.isExpanded);loadRevisionTable(props.item)"
            >
              <v-icon small> 
                {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
              </v-icon>
            </v-btn>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              {{ props.item.code }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              {{ props.item.name }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span v-html="props.item.description" />
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              {{ props.item.type }}
            </span>
          </td>
          
          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              <v-icon medium>
                {{ props.item.is_deduct_epf ? 'mdi mdi-check-outline text-success' : 'mdi mdi-close-outline text-danger' }}
              </v-icon>
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span>
              {{ props.item.retirement_age? props.item.retirement_age:'N/A' }}
            </span>
          </td>

          <td :class="props.isExpanded? 'remove-bottom-border selected':'border-bottom' ">
            <span v-if="statusFilter">
              <setup-payroll-contribution-or-deduction-dialog-edit
                v-if="$hasPermissionTo(['update contribution or deductions'])"
                :contribution-deduction="props.item"
                @updated="refreshData"
              />
              <span class="mx-1" />
            
              <setup-payroll-contribution-or-deduction-dialog-delete-mobile
                v-if="$hasPermissionTo(['delete contribution or deductions']) && $vuetify.breakpoint.smAndDown"
                :contribution-deduction="props.item"
                @deleted="refreshData"
              />
         
              <setup-payroll-contribution-or-deduction-dialog-delete
                v-if="$hasPermissionTo(['delete contribution or deductions']) && $vuetify.breakpoint.mdAndUp"
                :contribution-deduction="props.item"
                @deleted="refreshData"
              />
            </span>
            <span v-else>
              <setup-payroll-contribution-or-deduction-dialog-restore
                v-if="$hasPermissionTo(['restore contribution or deductions']) && $vuetify.breakpoint.mdAndUp"
                :contribution-deduction="props.item"
                @restored="refreshData"
              />

              <setup-payroll-contribution-or-deduction-dialog-restore-mobile
                v-if="$hasPermissionTo(['restore contribution or deductions']) && $vuetify.breakpoint.smAndDown"
                :contribution-deduction="props.item"
                @restored="refreshData"
              />
            </span>
          </td>
        </tr>
      </template>

      <template v-slot:expanded-item="{ headers,item }">
        <td
          :colspan="headers.length"
          class="py-2"
          style="background-color: rgba(0, 0, 0, .05);"
        >
          <v-skeleton-loader 
            v-if="loading"
            type="table" 
          />
          <div
            v-else
            class="mb-2"
          >
            <span class="font-calibri font-16 line-height-1 font-grey font-weight-bold">Revisions </span>
            <span v-if="statusFilter">
              <setup-payroll-contribution-or-deduction-contribution-or-deduction-revision-dialog-create
                v-if="$hasPermissionTo(['create contribution or deduction revisions']) && checkInUseRevisionTable"
                :contribution-deduction="item"
                @created="loadRevisionTable(item)"
              />

              <v-tooltip
                bottom
              >
                <template
                  v-slot:activator="{ on: tooltip }"
                >
                  <v-btn
                    color="hrissuccess"
                    dark
                    icon
                    medium
                    @click="downloadTemplateWithLatestValue(item, types, revisionTableTabs)"
                    v-on="{ ...tooltip }"
                  >
                    <v-icon class="mr-1">mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.name }} Template</span>
              </v-tooltip>
           
            </span>
          </div>
          <v-row
            no-gutters
            class="elevation-1"
            style="background:white"
          >
            <v-col
              cols="3"
              class="my-2"
            >
              <span
                v-if="revisionTableTabs.length<1"
                class="pl-3"
              >
                No Data Available
              </span>
              <div
                v-for="tab in revisionTableTabs"
                v-else
                :key="tab.id"
              >
                <span
                  class="font-weight-bold pl-3 pointer-cursor"
                  @click="loadTypeTable(tab.id)"
                >
                  {{ tab.version }} ({{ tab.start_date }} - {{ tab.end_date?tab.end_date : 'N/A' }})
                </span> 
                <span v-if="statusFilter">
                  <setup-payroll-contribution-or-deduction-contribution-or-deduction-revision-dialog-edit
                    v-if="$hasPermissionTo(['update contribution or deduction revisions'])"
                    :contribution-deduction-revision="tab"
                    @revision-updated="loadRevisionTable(recordType)"
                  />
                </span>
              </div>
            </v-col>

            <v-col
              class="my-2"
              cols="9"
              style="border-left:1px solid #e6e6e6"
            >
              <v-data-table
                class="mx-2"
                :items="types"
                dense
                :headers="customHeaders"
                :loading="tableLoading2"
              >
                <template v-slot:item.wages_from="{ item }">
                  <span>
                    {{ item.wages_from/100 }}
                  </span>
                </template>
                
                <template v-slot:item.wages_to="{ item }">
                  <span>
                    {{ item.wages_to/100 }}
                  </span>
                </template>

                <template v-slot:item.employee_contribution="{ item }">
                  <span>
                    {{ item.employee_contribution/100 }}
                  </span>
                </template>

                <template v-slot:item.employer_contribution="{ item }">
                  <span>
                    {{ item.employer_contribution/100 }}
                  </span>
                </template>

                <template v-slot:item.total_contribution="{ item }">
                  <span>
                    {{ item.total_contribution/100 }}
                  </span>
                </template>

                <template v-slot:item.first_category_employer_contribution="{ item }">
                  <span>
                    {{ item.first_category_employer_contribution/100 }}
                  </span>
                </template>

                <template v-slot:item.first_category_employee_contribution="{ item }">
                  <span>
                    {{ item.first_category_employee_contribution/100 }}
                  </span>
                </template>

                <template v-slot:item.first_category_total_contribution="{ item }">
                  <span>
                    {{ item.first_category_total_contribution/100 }}
                  </span>
                </template>

                <template v-slot:item.second_category_employer_contribution="{ item }">
                  <span>
                    {{ item.second_category_employer_contribution/100 }}
                  </span>
                </template>

                <template v-slot:item.total="{ item }">
                  <span>
                    {{ item.total/100 }}
                  </span>
                </template>

                <template v-slot:item.chargeable_income_from="{ item }">
                  <span>
                    {{ item.chargeable_income_from/100 }}
                  </span>
                </template>

                <template v-slot:item.chargeable_income_to="{ item }">
                  <span>
                    {{ item.chargeable_income_to/100 }}
                  </span>
                </template>

                <template v-slot:item.tax_amount="{ item }">
                  <span>
                    {{ item.tax_amount/100 }}
                  </span>
                </template>

                <template v-slot:item.rate_on_excess="{ item }">
                  <span>
                    {{ item.rate_on_excess }}
                  </span>
                </template>

                <template v-slot:item.category_one="{ item }">
                  <span>
                    {{ item.category_one/100 }}
                  </span>
                </template>

                <template v-slot:item.category_two="{ item }">
                  <span>
                    {{ item.category_two/100 }}
                  </span>
                </template>

                <template v-slot:item.category_three="{ item }">
                  <span>
                    {{ item.category_three/100 }}
                  </span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table> 
  </div>
</template>

<script>
  import ExcelJS from 'exceljs'

  export default {
    components: {
      SetupPayrollContributionOrDeductionDialogCreate: () => import('@/components/hris/setup/payroll/contribution-or-deduction/DialogCreate'),
      SetupPayrollContributionOrDeductionDialogDelete: () => import('@/components/hris/setup/payroll/contribution-or-deduction/DialogDelete'),
      SetupPayrollContributionOrDeductionDialogRestore: () => import('@/components/hris/setup/payroll/contribution-or-deduction/DialogRestore'),
      SetupPayrollContributionOrDeductionDialogEdit: () => import('@/components/hris/setup/payroll/contribution-or-deduction/DialogEdit'),
      SetupPayrollContributionOrDeductionDialogDeleteMobile: () => import('@/components/hris/setup/payroll/contribution-or-deduction/DialogDeleteMobile'),
      SetupPayrollContributionOrDeductionDialogRestoreMobile: () => import('@/components/hris/setup/payroll/contribution-or-deduction/DialogRestoreMobile'),
      SetupPayrollContributionOrDeductionContributionOrDeductionRevisionDialogEdit: () => import('@/components/hris/setup/payroll/contribution-or-deduction/contribution-or-deduction-revision/DialogEdit'),
      SetupPayrollContributionOrDeductionContributionOrDeductionRevisionDialogCreate: () => import('@/components/hris/setup/payroll/contribution-or-deduction/contribution-or-deduction-revision/DialogCreate'),
    },
    data () {
      return {
        CoDs: [],
        trashedCoDs: [],
        headers: [
          {
            text: 'Code',
            align: 'left',
            value: 'code',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Description',
            align: 'left',
            value: 'description',
          },
          {
            text: 'Type',
            align: 'left',
            value: 'type',
          },
          {
            text: 'Deduct EPF',
            align: 'left',
            value: 'is_deduct_epf',
          },
          {
            text: 'Retirement Age',
            align: 'left',
            value: 'retirement_age',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: false,
        revisionTableTabs: [ ],
        types: [],
        epfHeaders: [
          {
            text: 'Base From',
            align: 'right',
            value: 'wages_from',
          },
          {
            text: 'Base To',
            align: 'right',
            value: 'wages_to',
          },
          {
            text: 'Emp\'er Contribution',
            align: 'right',
            value: 'employer_contribution',
          },
          {
            text: 'Emp\'ee Contribution',
            align: 'right',
            value: 'employee_contribution',
          },
          {
            text: 'Total Contribution',
            align: 'right',
            value: 'total_contribution',
          },
        ],
        tableLoading2: false,
        recordType: null,
        socsoHeaders: [
          {
            text: 'Base From',
            align: 'right',
            value: 'wages_from',
          },
          {
            text: 'Base To',
            align: 'right',
            value: 'wages_to',
          },
          {
            text: '1st Cat. Emp\'er Amt',
            align: 'right',
            value: 'first_category_employer_contribution',
          },
          {
            text: '1st Cat. Emp\'ee Amt',
            align: 'right',
            value: 'first_category_employee_contribution',
          },
          {
            text: '1st Cat. Total Amt',
            align: 'right',
            value: 'first_category_total_contribution',
          },
          {
            text: '2nd Cat. Emp\'er Amt',
            align: 'right',
            value: 'second_category_employer_contribution',
          },
        ],
        eisHeaders: [
          {
            text: 'Base From',
            align: 'right',
            value: 'wages_from',
          },
          {
            text: 'Base To',
            align: 'right',
            value: 'wages_to',
          },
          {
            text: 'Emp\'er Contribution',
            align: 'right',
            value: 'employer_contribution',
          },
          {
            text: 'Emp\'ee Contribution',
            align: 'right',
            value: 'employee_contribution',
          }, 
          {
            text: 'Total Contribution',
            align: 'right',
            value: 'total',
          },
        ],
        taxHeaders: [
          {
            text: 'Chargeable Income From',
            align: 'right',
            value: 'chargeable_income_from',
          },
          {
            text: 'Chargeable Income To',
            align: 'right',
            value: 'chargeable_income_to',
          },
          {
            text: 'Tax Amount',
            align: 'right',
            value: 'tax_amount',
          },
          {
            text: 'Rate (%)',
            align: 'center',
            value: 'rate_on_excess',
          }, 
          {
            text: 'Category 1',
            align: 'right',
            value: 'category_one',
          }, 
          {
            text: 'Category 2',
            align: 'right',
            value: 'category_two',
          }, 
          {
            text: 'Category 3',
            align: 'right',
            value: 'category_three',
          }, 
        ],
        loading: true,
      }
    },
    computed: {
      filteredCoDs () {
        return this.statusFilter ? this.CoDs : this.trashedCoDs
      },
      customHeaders () {
        if (this.recordType.type === 'epf') return this.epfHeaders
        if (this.recordType.type === 'eis') return this.eisHeaders
        if (this.recordType.type === 'tax') return this.taxHeaders

        return this.socsoHeaders
      },

      checkInUseRevisionTable () {
        return !this.revisionTableTabs.find(revisionTableTab => revisionTableTab.end_date === null)
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadCoDs () {
        this.tableLoading = true

        this.$api.contributionDeductions().list()
          .then(response => {
            this.CoDs = _.orderBy(response.data, ['code'], ['asc'])

            this.tableLoading = false
          })
      },
      loadTrashedCoDs () {
        this.$api.contributionDeductions().listTrashed()
          .then(response => {
            this.trashedCoDs = response.data
          })
      },
      refreshData () {
        this.loadCoDs()
        this.loadTrashedCoDs()
      },
      loadTypeTable (id) {
        this.tableLoading2 = true

        this.$api.codRevisionTypes(this.recordType.type).show(id)
          .then(res => {
            this.types = res.data
            this.tableLoading2 = false
            this.loading = false
          })
      },
   
      loadRevisionTable (item) {
        this.recordType = item

        this.$api.contributionDeductionRevisions().show(item.id)
          .then(res => {
            this.revisionTableTabs = _.orderBy(res.data, ['created_at'], ['desc'])

            this.loading = true
            this.loadTypeTable(this.revisionTableTabs.length > 0 ? this.revisionTableTabs[0].id : 0)
          })
      },   
      
      downloadTemplateWithLatestValue (cod, codRates, revisionVers) {
        let path = ''
        if (cod.type === 'eis') {
          path = '/templates/EIS Table Template.xlsx'
        } else if (cod.type === 'tax') {
          path = '/templates/Tax Table Template.xlsx'
        } else if (cod.type === 'socso') {
          path = '/templates/SOCSO Table Template.xlsx'
        } else {
          path = '/templates/EPF Table Template.xlsx'
        }

        const matchingRevision = revisionVers.find((revisionVer) => 
          revisionVer.id === codRates[0].contribution_deduction_revision_id
        )
        let verName = matchingRevision ? matchingRevision.version : null

        // change this template based on codRates name
        fetch(path)
          .then(response => response.blob())
          .then(templateBlob => {
            // Create a workbook from the template data
            const workbook = new ExcelJS.Workbook()
            return workbook.xlsx.load(templateBlob)
          })
          .then(workbook => {
            // Access the desired worksheet
            const worksheet = workbook.getWorksheet('Sheet1')

            // Stamp the values into the desired cells
            codRates.forEach((codRate, index) => {
              let newRow = index + 2
              if (cod.type === 'tax') {
                worksheet.getCell(`A${newRow}`).value = codRate.chargeable_income_from / 100
                worksheet.getCell(`B${newRow}`).value = codRate.chargeable_income_to / 100
                worksheet.getCell(`C${newRow}`).value = codRate.tax_amount / 100
                worksheet.getCell(`D${newRow}`).value = codRate.rate_on_excess
                worksheet.getCell(`E${newRow}`).value = codRate.category_one / 100
                worksheet.getCell(`F${newRow}`).value = codRate.category_two / 100
                worksheet.getCell(`G${newRow}`).value = codRate.category_three / 100
              } else if (cod.type === 'socso') {
                worksheet.getCell(`A${newRow}`).value = codRate.wages_from / 100
                worksheet.getCell(`B${newRow}`).value = codRate.wages_to / 100
                worksheet.getCell(`C${newRow}`).value = codRate.first_category_employer_contribution / 100
                worksheet.getCell(`D${newRow}`).value = codRate.first_category_employee_contribution / 100
                worksheet.getCell(`E${newRow}`).value = codRate.first_category_total_contribution / 100
                worksheet.getCell(`F${newRow}`).value = codRate.second_category_employer_contribution / 100
              } else {
                worksheet.getCell(`A${newRow}`).value = codRate.wages_from / 100
                worksheet.getCell(`B${newRow}`).value = codRate.wages_to / 100
                worksheet.getCell(`C${newRow}`).value = codRate.employer_contribution / 100
                worksheet.getCell(`D${newRow}`).value = codRate.employee_contribution / 100
                worksheet.getCell(`E${newRow}`).value = (cod.type === 'eis' ? codRate.total : codRate.total_contribution) / 100
              }

              worksheet.getCell(`A${newRow}`).numFmt = '0.00'
              worksheet.getCell(`B${newRow}`).numFmt = '0.00'
              worksheet.getCell(`C${newRow}`).numFmt = '0.00'
              worksheet.getCell(`D${newRow}`).numFmt = '0.00'
              worksheet.getCell(`E${newRow}`).numFmt = '0.00'
              worksheet.getCell(`F${newRow}`).numFmt = '0.00'
              worksheet.getCell(`G${newRow}`).numFmt = '0.00'

              worksheet.getColumn('D').alignment = { horizontal: 'right' }
            })

            // Create a Blob from the modified workbook
            return workbook.xlsx.writeBuffer()
          })
          .then(modifiedBlob => {
            // Create a download link and trigger the download
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([modifiedBlob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
            link.download = cod.name + ' Table Template ' + verName + '.xlsx'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
          .catch(error => {
            console.error('Error appending data to template:', error)
          })
      },      
    },
  }
</script>

<style scoped>
.remove-bottom-border {
  border-bottom: 0px !important
}

.selected{
  background-color: rgba(0, 0, 0, .05);
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}

.pointer-cursor{
  cursor: pointer;
}

.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}
</style>
